const PEER_CONFIG = {
  host: process.env.VUE_APP_SIGNALING_HOST,
  port: process.env.VUE_APP_SIGNALING_PORT,
  secure: process.env.NODE_ENV !== 'development',
  iceServers: [
    { 'urls': 'stun:35.78.58.220:80' },
    { 'urls': 'turn:35.78.58.220:80?transport=tcp', 'username': 'ice-todokusuri','credential': 'ub-1i8A~tSXY9Dva' }
  ]
}

export default PEER_CONFIG
